define(["exports", "hyperhtml"], function (_exports, _hyperhtml) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject8() {
    const data = _taggedTemplateLiteral(["\n                  with <code>", "</code> at the start of your\n                  email's subject\n                "]);

    _templateObject8 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["\n          <p>\n            If you wish to make comments regarding this document, please send\n            them to\n            <a href=\"", "\"\n              >", "@w3.org</a\n            >\n            (<a href=\"", "\">subscribe</a>,\n            <a\n              href=\"", "\"\n              >archives</a\n            >)", ".\n          </p>\n        "]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["\n            Please note that under the\n            <a href=\"https://www.w3.org/community/about/agreements/cla/\"\n              >W3C Community Contributor License Agreement (CLA)</a\n            >\n            there is a limited opt-out and other conditions apply.\n          "]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["\n            Please note that under the\n            <a href=\"https://www.w3.org/community/about/agreements/final/\"\n              >W3C Community Final Specification Agreement (FSA)</a\n            >\n            other conditions apply.\n          "]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["\n                    Instead, see\n                    <a href=\"", "\">", "</a> for the\n                    Editor's draft.\n                  "]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["\n                    of pull request\n                    <a href=\"", "\">#", "</a>\n                  "]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n          <details class=\"annoying-warning\" open=\"\">\n            <summary\n              >This is a\n              preview", "</summary\n            >\n            <p>\n              Do not attempt to implement this version of the specification. Do\n              not reference this version as authoritative in any way.\n              ", "\n            </p>\n          </details>\n        "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n    <h2>", "</h2>\n    ", "\n    <p>\n      This specification was published by the\n      <a href=\"", "\">", "</a>. It is not a W3C Standard nor is it\n      on the W3C Standards Track.\n      ", "\n      Learn more about\n      <a href=\"https://www.w3.org/community/\"\n        >W3C Community and Business Groups</a\n      >.\n    </p>\n    ", "\n    ", "\n    ", "\n    ", "\n  "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  var _default = (conf, opts) => {
    return (0, _hyperhtml.default)(_templateObject(), conf.l10n.sotd, conf.isPreview ? (0, _hyperhtml.default)(_templateObject2(), conf.prUrl && conf.prNumber ? (0, _hyperhtml.default)(_templateObject3(), conf.prUrl, conf.prNumber) : "", conf.edDraftURI ? (0, _hyperhtml.default)(_templateObject4(), conf.edDraftURI, conf.edDraftURI) : "") : "", conf.wgURI, conf.wg, conf.isCGFinal ? (0, _hyperhtml.default)(_templateObject5()) : (0, _hyperhtml.default)(_templateObject6()), !conf.sotdAfterWGinfo ? opts.additionalContent : "", conf.wgPublicList ? (0, _hyperhtml.default)(_templateObject7(), opts.mailToWGPublicListWithSubject, conf.wgPublicList, opts.mailToWGPublicListSubscription, "https://lists.w3.org/Archives/Public/".concat(conf.wgPublicList, "/"), conf.subjectPrefix ? (0, _hyperhtml.default)(_templateObject8(), conf.subjectPrefix) : "") : "", conf.sotdAfterWGinfo ? opts.additionalContent : "", opts.additionalSections);
  };

  _exports.default = _default;
});
//# sourceMappingURL=cgbg-sotd.js.map